// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: feedback.proto

export const protobufPackage = 'compasspb';

/**
 * FeedbackType discriminates which entity this feedback is attached to.
 * Numeric values are used in JSON serialization per project conventions.
 */
export enum FeedbackType {
  /** FEEDBACK_TYPE_UNSPECIFIED - Default — must not be used in requests */
  FEEDBACK_TYPE_UNSPECIFIED = 0,
  /** FEEDBACK_TYPE_EVALUATION - Feedback on a whole evaluation — requires evaluation_id */
  FEEDBACK_TYPE_EVALUATION = 1,
  /** FEEDBACK_TYPE_EVALUATION_FINDING - Feedback on a specific finding — requires evaluation_id + finding_index */
  FEEDBACK_TYPE_EVALUATION_FINDING = 2,
  /** FEEDBACK_TYPE_CASE_RECORD - Feedback on a case record — requires case_record_id */
  FEEDBACK_TYPE_CASE_RECORD = 3,
  /** FEEDBACK_TYPE_CALL - Feedback on a call within a case record — requires case_record_id + call_id */
  FEEDBACK_TYPE_CALL = 4,
}

/** FeedbackInfo is the public view of a feedback record. */
export interface FeedbackInfo {
  /** Unique identifier */
  id?: string | undefined;
  /** Discriminator: which entity this feedback applies to */
  feedback_type?: FeedbackType | undefined;
  /** Free-text feedback content */
  text?: string | undefined;
  /**
   * Rating 0.0–1.0. Absent (null/undefined) means no rating was provided.
   * Using optional so clients can distinguish "not rated" from a 0.0 score.
   */
  rating?: number | undefined;
  /** Owning organization (always set) */
  organization_id?: string | undefined;
  /** Owning program (optional — set for CASE_RECORD and CALL types) */
  program_id?: string | undefined;
  /** Entity references — populated based on feedback_type */
  evaluation_id?: string | undefined;
  /**
   * Finding index within the evaluation (0-based). Set for EVALUATION_FINDING type.
   * Optional so that nil (not set) is distinguishable from index 0.
   */
  finding_index?: number | undefined;
  case_record_id?: string | undefined;
  call_id?: string | undefined;
  /** Audit fields */
  created_by?: string | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
}

export interface SubmitFeedbackRequest {
  organization_id?: string | undefined;
  /** Program ID — required for CASE_RECORD and CALL types */
  program_id?: string | undefined;
  feedback_type?: FeedbackType | undefined;
  text?: string | undefined;
  /** Rating 0.0–1.0. Optional if text is provided. */
  rating?: number | undefined;
  /** Entity references — required fields depend on feedback_type */
  evaluation_id?: string | undefined;
  /** 0-based index of the finding. Required for EVALUATION_FINDING type. */
  finding_index?: number | undefined;
  case_record_id?: string | undefined;
  call_id?: string | undefined;
}

export interface SubmitFeedbackResponse {
  feedback?: FeedbackInfo | undefined;
}

export interface GetFeedbackRequest {
  organization_id?: string | undefined;
  feedback_id?: string | undefined;
}

export interface GetFeedbackResponse {
  feedback?: FeedbackInfo | undefined;
}

export interface ListFeedbackRequest {
  organization_id?: string | undefined;
  /** Optional program filter */
  program_id?: string | undefined;
  /** Optional type filter — 0 returns all types */
  feedback_type?: FeedbackType | undefined;
  evaluation_ids?: string[] | undefined;
  case_record_id?: string | undefined;
  call_id?: string | undefined;
  /** Pagination */
  limit?: number | undefined;
  start_after_id?: string | undefined;
}

export interface ListFeedbackResponse {
  feedback?: FeedbackInfo[] | undefined;
  /** Empty string means no more pages */
  next_cursor?: string | undefined;
}

export interface UpdateFeedbackRequest {
  organization_id?: string | undefined;
  feedback_id?: string | undefined;
  /** At least one of text or rating must be provided */
  text?: string | undefined;
  rating?: number | undefined;
}

export interface UpdateFeedbackResponse {
  feedback?: FeedbackInfo | undefined;
}

export interface DeleteFeedbackRequest {
  organization_id?: string | undefined;
  feedback_id?: string | undefined;
}

export interface DeleteFeedbackResponse {}

/**
 * FeedbackService provides operations for submitting and managing feedback
 * on evaluations, evaluation findings, case records, and calls.
 */
export interface FeedbackService {
  /**
   * SubmitFeedback creates a new feedback record.
   * For EVALUATION/EVALUATION_FINDING types, org-level feedback:write permission is required.
   * For CASE_RECORD/CALL types, program-level feedback:write permission is required.
   */
  submitFeedback(request: SubmitFeedbackRequest): Promise<SubmitFeedbackResponse>;
  /** GetFeedback retrieves a single feedback record by ID. */
  getFeedback(request: GetFeedbackRequest): Promise<GetFeedbackResponse>;
  /** ListFeedback lists feedback records filtered by entity. */
  listFeedback(request: ListFeedbackRequest): Promise<ListFeedbackResponse>;
  /**
   * UpdateFeedback updates the text and/or rating of an existing feedback record.
   * Only the original creator of the feedback may update it (owned scope enforced in service layer).
   */
  updateFeedback(request: UpdateFeedbackRequest): Promise<UpdateFeedbackResponse>;
  /**
   * DeleteFeedback soft-deletes a feedback record.
   * Only the original creator of the feedback may delete it (owned scope enforced in service layer).
   */
  deleteFeedback(request: DeleteFeedbackRequest): Promise<DeleteFeedbackResponse>;
}
